import { useCallback, useEffect } from "react"

export default function useUnsavedChangesAlert({ savedData, currentData }) {
  const handleUnsavedLeave = useCallback(event => {
    event.preventDefault()
    return (event.returnValue = "")
  }, [])
  const handleTurbolinksClick = useCallback(e => {
    e.preventDefault()
  }, [])
  const removeHandlers = () => {
    document.removeEventListener("turbolinks:click", handleTurbolinksClick)
    window.removeEventListener("beforeunload", handleUnsavedLeave)
  }

  useEffect(() => {
    const hasChanges = JSON.stringify(savedData) !== JSON.stringify(currentData)

    if (hasChanges) {
      document.addEventListener("turbolinks:click", handleTurbolinksClick)
      window.addEventListener("beforeunload", handleUnsavedLeave)
    } else {
      removeHandlers()
    }
  }, [savedData, currentData])

  useEffect(
    () => () => {
      removeHandlers()
    },
    []
  )
  return { removeHandlers }
}
